import { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../utils/supabase';
import { getCache, setCache } from '../utils/cache';
import RenderMonitor from '../components/RenderMonitor';

function TeamBootcamps() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const passedTeamName = location?.state?.teamName || '';
  const [bootcamps, setBootcamps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [teamName, setTeamName] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError('');
      const CACHE_KEY = `team.${id}.bootcamps.v1`;
      const cached = getCache(CACHE_KEY, 2 * 60 * 1000);
      if (cached) {
        setTeamName(cached.teamName || '');
        setBootcamps(cached.bootcamps || []);
        setLoading(false);
        return;
      }
      // Prefer team name from navigation state; fallback to DB if missing
      const passedName = passedTeamName;
      let resolvedTeamName = passedName || '';
      if (passedName) {
        setTeamName(passedName);
      } else {
        console.log('[TEAM_BOOTCAMPS][DB] SELECT team name');
        const { data: teamData } = await supabase
          .from('teams')
          .select('name')
          .eq('id', id)
          .single();
        if (teamData && teamData.name) {
          resolvedTeamName = teamData.name;
          setTeamName(teamData.name);
        }
      }
      // Fetch bootcamps for this team
      console.log('[TEAM_BOOTCAMPS][DB] SELECT bootcamps');
      const { data, error } = await supabase
        .from('bootcamps')
        .select('id, start_date, end_date, stutter_time, courses(name), teams(name)')
        .eq('team_id', id);
      if (error) {
        setError('Could not fetch bootcamps');
        setLoading(false);
        return;
      }
      setBootcamps(data || []);
      const nameForCache = resolvedTeamName;
      setCache(CACHE_KEY, { teamName: nameForCache || '', bootcamps: data || [] });
      setLoading(false);
    };
    fetchData();
  }, [id, passedTeamName]);

  const formatDate = (date) => {
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }).format(new Date(date));
  };

  return (
    <div className="modern-container-narrow">
      <RenderMonitor componentName="TeamBootcamps" />
      <button
        type="button"
        onClick={() => {
          const cid = location?.state?.clientId;
          const rid = location?.state?.regionId;
          if (cid && rid) {
            navigate(`/client/${cid}/region/${rid}`, { state: { refresh: Date.now() } });
            return;
          }
          navigate(-1);
        }}
        className="modern-button modern-button-secondary modern-mb-6"
      >
        ← Back
      </button>
      <div className="modern-card">
        <h1 className="modern-title">Bootcamps for {teamName || 'Team'}</h1>
        {loading ? (
          <div className="modern-loading">Loading bootcamps...</div>
        ) : error ? (
          <div className="modern-error">{error}</div>
        ) : bootcamps.length === 0 ? (
          <p style={{ color: '#64748b', fontStyle: 'italic' }}>No bootcamps for this team.</p>
        ) : (
          <div className="modern-flex modern-flex-col modern-gap-4">
            {bootcamps.map(bc => (
              <div key={bc.id} className="modern-card">
                <div className="modern-flex modern-justify-between modern-items-center">
                  <div>
                    <div style={{ fontWeight: 600 }}>{bc.courses?.name || 'Unknown Course'}</div>
                    <div style={{ color: '#64748b', fontSize: 14 }}>
                      {formatDate(bc.start_date)} - {formatDate(bc.end_date)}
                    </div>
                  </div>
                  <button
                    className="modern-button modern-button-info"
                    onClick={() => navigate(`/bootcamp/${bc.id}`)}
                  >
                    View Bootcamp →
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default TeamBootcamps; 